<template>
  <div class="bg-green-80">
    <div class="p-16">
      <BlTextAv weight="bold" variation="body-16" tag="h2" color="inverse">Kelas-kelas pilihan</BlTextAv>
    </div>

    <div class="space-y-2 pb-28">
      <div
        v-for="(courses, i) in displayableCourses"
        :key="`scrollable-${i}`"
        class="courses-group ph-16 flex scroll-pl-4 space-x-2 overflow-x-auto snap-x"
      >
        <div v-for="course in courses" :key="course.id" class="snap-start w-[148px] shrink-0 first:pl-6">
          <PrakerjaCard
            :course="course"
            :course-type="course.course_type"
            class="min-w-[148px]"
            referrer="prakerja_greenbox"
            is-hide-border
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import PrakerjaCard from '../PrakerjaCard/PrakerjaCard.vue';
import {mapActions, mapGetters} from 'vuex';
import {BlTextAv} from '@bukalapak/bazaar-mweb-latest';
import chunk from 'lodash/chunk';

export default {
  name: 'PrakerjaBestCourses',
  components: {BlTextAv, PrakerjaCard},
  computed: {
    ...mapGetters('courses', ['getBestCourses']),
    displayableCourses() {
      if (this.getBestCourses.length > 6) {
        return chunk(this.getBestCourses, Math.ceil(this.getBestCourses.length / 2));
      }
      return [this.getBestCourses];
    },
  },
  created() {
    this.init();
  },
  methods: {
    ...mapActions('courses', ['fetchBestCourses']),
    init() {
      this.fetchBestCourses();
    },
  },
};
</script>
